<template>
  <main class="object-page">
    <SearchBox v-if="showSearch"
               v-model="siteSearch"
               :placeholder="$t('object1Page.searchSites')"
               @search="onSiteSearch"
    />
    <div class="container">
      <div>
        <TaskList :tasks="shownObject1s"
                  show-header="true"
                  :header-text="$t('object1Page.object1s')"
                  object-type="objects"
                  :table-columns="['Name', 'Customer']"
                  preference-key="sites"
        />
      </div>
    </div>
  </main>
</template>

<script setup>
import i18n from '../locales/i18n'
import { onMounted, computed, ref } from 'vue'
import { useStore } from 'vuex'
import TaskList from '@/components/task/TaskList.vue'
import SearchBox from '@/components/inputs/SearchBox.vue'
import { isReportEnvironment } from '@/utils/environment.js'
import { loadPreference, savePreference } from '@/utils/preferences.js'
// VueX
const store = useStore()

const object1s = computed(() => store.state.object1.object1s)

// Site search (UK/GB02) on name, number and customer, saved per user for the next session.
// All the user's sites are loaded, so the search filters them here.
const showSearch = isReportEnvironment()
const siteSearchPreference = 'sitesSearch'
const siteSearch = ref(loadPreference(siteSearchPreference) || '')
const appliedSearch = ref(siteSearch.value.trim().toLowerCase())

const shownObject1s = computed(() => {
  const search = appliedSearch.value
  if (!showSearch || !search) {
    return object1s.value
  }
  return object1s.value.filter(site =>
    [site.Name, site.Nr, site.Customer?.Name].some(value => (value || '').toLowerCase().includes(search))
  )
})

function onSiteSearch (search) {
  savePreference(siteSearchPreference, search)
  appliedSearch.value = search.toLowerCase()
}

onMounted(async () => {
  store.dispatch('object1/getBaseData')
  store.commit('sidebar/setCurrentPageHeaderText', i18n.global.t('object1Page.object1'))
})

</script>

<style lang="scss" scoped>
.task-page {
  height: 100vh;
  overflow-y: scroll;
  font-family: 'Lexend', sans-serif;
  text-align: center;
  color: #2c3e50;
  background: linear-gradient(90deg, var(--taskBackgroundColor1) 0%, var(--taskBackgroundColor2) 10px);
}

.container{
  padding: 1rem;
  min-width: unset;
  width:1;
}

.styled-table {
  table-layout: fixed;
  border-collapse: collapse;
  margin: 5px 0;
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

.styled-table thead tr {
  background-color: var(--mainBlue);
  color: white;
  text-align: left;
}

.styled-table th {
  padding: 12px 15px;
  text-align: left;
}

.styled-table tbody tr {
  border-bottom: 1px solid lightgrey;
  background-color: white;
  color: black;
}

.styled-table tbody tr:nth-of-type(4n-1),
.styled-table tbody tr:nth-of-type(4n) {
  background-color: var(--alternatingListColor);
  color: black;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 3px solid var(--mainBlue);
}

.table-row:hover {
  background-color: #f5f5f5;
}

.button {

}

</style>
